import React, { useContext, useEffect, useState } from 'react'
import { FiPlus, FiTrash } from 'react-icons/fi'
import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'

import { Container } from './styles'
import Card from '~/components/Card'
import { api, authHeaders } from '~/services/api'
import formUtils from '~/util/form'
import Table from '~/components/Table'
import Spinner from '~/components/Spinner'
import { Button, Select } from '~/components/Form'
import Modal from '~/components/Modal'
import { TipContext } from '~/contexts/TipContext'
import { loadTips } from '~/util/tip'

export default function () {
	const { setCodigo, tips } = useContext(TipContext)

	const [validadores, setValidadores] = useState(null)
	const [diretores, setDiretores] = useState(null)
	const [mostrarCadastro, setMostrarCadastro] = useState(false)

	async function loadValidadores() {
		setValidadores(null)

		const response = await api.get('visita_diretoria/validador', authHeaders())

		setValidadores(response
			.filter(item => item.pessoa.id !== 1)
			.map(item => ({
				id: item.pessoa.id,
				nome: item.pessoa.nome
			})))
	}

	async function loadDiretores() {
		const response = await api.get('diretoria', authHeaders())

		const diretoresDisponiveis = response.filter(item => !validadores.some(v => v.id === item.pessoa.id))

		setDiretores(diretoresDisponiveis.map(item => ({
			id: item.pessoa.id,
			nome: item.pessoa.nome
		})))
	}

	async function handleDelete(item) {
		try {
			await api.delete(`visita_diretoria/validador/${item.id}`, authHeaders())

			toast.success('O validador foi removido.')

			loadValidadores()
		} catch (e) {
			toast.error(e.msg)
		}
	}

	async function handleCadastrar(values) {
		try {
			values = formUtils.extractFormValues(values)

			await api.post('visita_diretoria/validador', {
				pessoa_id: values.diretor
			}, authHeaders())
			
			loadValidadores()

			setMostrarCadastro(false)
		} catch(e) {
			toast.error(e.msg)
		}
	}

	useEffect(() => {
		loadValidadores()
	}, [])

	useEffect(() => {
		loadTips(setCodigo, 'form_visita_diretoria_validador')
	}, [])

	useEffect(() => {
		if(validadores) {
			loadDiretores()
		}
	}, [validadores])

	if (!validadores || !diretores) {
		return <Spinner />
	}

	return (
		<>
			<Container>
				<main>
					<Card>
						<h1>Validadores de atividades da diretoria</h1>

						<p style={{ gridArea: 'tip', margin: 8 }}>{tips?.formulario}</p>

						<div className="flex justify-end">
							<Button className="transparent" onClick={() => { setMostrarCadastro(true) }}>
								Incluir validador
								<FiPlus size={16} />
							</Button>
						</div>

						<Table
							headers={[
								{ name: 'nome', value: 'Validador' }
							]}
							data={validadores}
							actions={[
								{
									action: handleDelete,
									icon: FiTrash,
									iconSize: 16,
									name: 'Remover',
									confirmation: 'Deseja realmente remover este validador?'
								}
							]}
						/>
					</Card>
				</main>
			</Container>

			<Modal
				isOpen={mostrarCadastro}
				handleClose={() => {
					setMostrarCadastro(false)
				}}
				title="Novo validador"
			>
				<Formik
					onSubmit={handleCadastrar}
					initialValues={{
						diretor: null
					}}
				>
					{({ setFieldValue, isSubmitting }) => (
						<Form className="flex flex-col gap-4">
							<Select 
								name="diretor"
								label="Diretor"
								options={diretores.map(diretor => ({
									label: diretor.nome,
									value: diretor.id
								}))}
								onChange={(selected, meta) => {
									setFieldValue(meta.name, selected)
								}}
							/>

							<Button type="submit" className="white w-fit self-end" loading={isSubmitting}>
								Incluir como validador
								<FiPlus size={16} />
							</Button>
						</Form>
					)}
				</Formik>
			</Modal>
		</>
	)
}
